import { Inject, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateAsuntoRequest } from '@models/asunto/createAsuntoRequest.model';
import { UpdateAsuntoRequest } from '@models/asunto/updateAsuntoRequest.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogAsuntosComponent } from '../dialog-asuntos/dialog-asuntos.component';
import { AsuntoService } from '@services/asunto/asuntos.service';
import { AccionesDialog } from '@models/base/identificadores.model';
import { BreakpointObserver } from '@angular/cdk/layout';
import { A11yModule } from '@angular/cdk/a11y';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { CdkTableModule } from '@angular/cdk/table';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  imports: [
      MatCardModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatMenuModule,
    MatButtonModule,
    MatDividerModule,
    MatRippleModule,
    FormsModule,
    ReactiveFormsModule,
    CdkTableModule,
    NgxSpinnerModule,
    AppRolesDirective,
    ],
    standalone:true,
  selector: 'app-asuntos',
  templateUrl: './asuntos.component.html',
  styleUrls: ['./asuntos.component.css']
})

export class AsuntosComponent implements OnInit {
  dataSource = new MatTableDataSource<BaseDto>();
  obj!: undefined
  displayedColumns: string[] = [];
  data = false

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }
  constructor(
    public dialog: MatDialog,
    private AsuntoService: AsuntoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver
  ) {


    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        [ 'descripcion', 'accion'] :
        [ 'descripcion', 'accion'];
    });
  }


  ngOnInit() {
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.getAllAsuntos();
  }

  getAllAsuntos() {
    this.spinner.show()
    this.AsuntoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data =  data.sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()))
          this.data = this.dataSource.data.length >= 1 ?  true : false
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError( error, "Error");
        }
      )
  }

  openDialog(action: any, obj: { action?: any; }) {
    obj.action = action;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "50%",
    dialogConfig.data = obj

    const dialogRef = this.dialog.open(DialogAsuntosComponent,
      dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Agregar) {
        this.addRowData(result.data);
      } else if (result.event == AccionesDialog.Modificar) {
        this.updateRowData(result.data);
      } else if (result.event == AccionesDialog.Eliminar) {
        this.deleteRowData(result.data);
      }
    });
  }

  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  addRowData(row_obj: { descripcion: any; }) {
    this.spinner.show()
    let createAsuntoRequest = new CreateAsuntoRequest
    createAsuntoRequest.descripcion = row_obj.descripcion

    let existe = false
    this.dataSource.data.forEach((element: { descripcion: any; }, index: any) => {
      if (element.descripcion === row_obj.descripcion)
        existe = true
    });

    if (createAsuntoRequest && !existe) {
      this.AsuntoService.create(createAsuntoRequest)
        .subscribe(
          data => {
            this.spinner.hide()
            this.dataSource.data.push({
              id: data.entidad.id,
              descripcion: row_obj.descripcion
            });
            this.table.renderRows();
            this.dataSource.data = this.dataSource.data.filter((value: { id: number; descripcion: string; }, key: any) => {
              return true;
            });
            this.data = this.dataSource.data.length >= 1 ?  true : false
            this.snackBar.showSuccess("Registro agregado correctamente.", "Exito");
          },
          error => {
            this.snackBar.showError( error, "Error");
          }
        )
    }
    else {
      this.spinner.hide()
      this.snackBar.showError("El registro ya existe", "Error");
    }

  }
  updateRowData(row_obj: { id: number; descripcion: string; }) {
    this.spinner.show()
    let updateAsuntoRequest = new UpdateAsuntoRequest
    updateAsuntoRequest.id = row_obj.id
    updateAsuntoRequest.descripcion = row_obj.descripcion

    let existe = false
    this.dataSource.data.forEach((element: { descripcion: string; }, index: any) => {
      if (element.descripcion === row_obj.descripcion)
        existe = true
    });
    if (updateAsuntoRequest && !existe) {
      this.AsuntoService.update(updateAsuntoRequest)
        .subscribe(
          data => {
            this.spinner.hide()
            this.dataSource.data = this.dataSource.data.filter((value: { id: number; descripcion: string; }, key: any) => {
              if (value.id == row_obj.id) {
                value.descripcion = row_obj.descripcion;
              }
              return true;
            });
            this.data = this.dataSource.data.length >= 1 ?  true : false
            this.snackBar.showSuccess("Registro actualizado correctamente.", "Exito");
          },
          error => {
            this.spinner.hide()
            this.snackBar.showError( error, "Error");
          })
    }
    else {
      this.spinner.hide()
      this.snackBar.showWarn("El registro ya existe", "Error");
    }
  }

  deleteRowData(row_obj: { id: number; }) {
    this.AsuntoService.delete(row_obj.id)
        .subscribe(
          data => {
            this.spinner.hide()
            this.dataSource.data = this.dataSource.data.filter((value: { id: number; }, key: any) => {
              return value.id != row_obj.id;
            });
            this.data = this.dataSource.data.length >= 1 ?  true : false
            this.snackBar.showSuccess("Registro dado de baja correctamente.", "Exito");
          },
          error => {
            this.spinner.hide()
            this.snackBar.showError( error, "Error");
          })

  }

}
